import { Controller } from "stimulus";
import Rails from "rails-ujs";

export default class extends Controller {

  static targets = ["productsList", "completeOrderBtn"];

  connect() {

    var cartCheckboxes = this.element.querySelectorAll(".product-ready-checkbox");

    cartCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", (e) => {
       
        var productType = e.target.id.includes("custom_product") ? "custom_product" : "product";
        var productId = e.target.value;
        var cartId = e.target.closest(".cart-products-list").dataset.cartId;
        var checked = e.target.checked;
        this.saveCartCheckedCheckboxes(cartId, productType, productId, checked);

        var selectedCheckBoxes = this.element.querySelectorAll(".product-ready-checkbox:checked");
        if (selectedCheckBoxes.length == cartCheckboxes.length) {
          this.completeOrderBtnTarget.click();
        }



      });
    });
  }

  toggleProductsList() {
    this.productsListTarget.classList.toggle("hidden");
  }

  saveCartCheckedCheckboxes(cartId, productType, productId, checked) {
    var data = {product_type: productType, product_id: productId, checked: checked.toString()};
    fetch(`/admin/shopping_carts/${cartId}/save_checked_checkboxes`, {
      method: "post",
      credentials: "same-origin",
      headers: {
        'Accept': "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.ok) {

      }
    });
  }




}
